<div
  class="color-picker-overlay"
  [class.is-active]="_isColorPickerOpened"
></div>

<div
  class="tool-bar-container"
  cdkDrag
  cdkDragBoundary="viewer-root"
  (cdkDragStarted)="_onToolBarDragStarted()"
>
  <div class="tool-bar" (touchmove)="$event.preventDefault()">
    <button
      [class.is-on]="_selectedTool === _Tool.Pen1"
      (pointerdown)="_onSelectTool(_Tool.Pen1)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Pen1"
        width="16"
        height="16"
        viewBox="0 0 24 20"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.14258 19.8927L12.1926 19.8927C13.5259 19.8927 14.7676 19.2344 15.5092 18.126C16.2509 17.026 16.4009 15.626 15.9009 14.3927L13.2092 7.73438L7.05091 7.73438L2.14258 19.8927Z"
          [attr.fill]="this._penConfigs['pen1']!.color"
          [attr.fill-opacity]="this._penConfigs['pen1']!.opacity"
        />
        <path
          d="M10.1359 0.11084L7.46094 6.73584L12.8109 6.73584L10.1359 0.11084Z"
          [attr.fill]="this._penConfigs['pen1']!.color"
          [attr.fill-opacity]="this._penConfigs['pen1']!.opacity"
        />
      </svg>
      <span class="weight-value" [class.is-on]="_selectedTool === _Tool.Pen1">{{
        this._penConfigs['pen1']!.width
      }}</span>
      <span
        class="select-highlight"
        [class.is-on]="_selectedTool === _Tool.Pen1"
      ></span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Pen2"
      (pointerdown)="_onSelectTool(_Tool.Pen2)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Pen2"
        width="18"
        height="14"
        viewBox="0 0 26 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.14258 19.8927L12.1926 19.8927C13.5259 19.8927 14.7676 19.2344 15.5092 18.126C16.2509 17.026 16.4009 15.626 15.9009 14.3927L13.2092 7.73438L7.05091 7.73438L2.14258 19.8927Z"
          fill="currentColor"
          [attr.fill]="this._penConfigs['pen2']!.color"
          [attr.fill-opacity]="this._penConfigs['pen2']!.opacity"
        />
        <path
          d="M10.1359 0.11084L7.46094 6.73584L12.8109 6.73584L10.1359 0.11084Z"
          fill="currentColor"
          [attr.fill]="this._penConfigs['pen2']!.color"
          [attr.fill-opacity]="this._penConfigs['pen2']!.opacity"
        />
      </svg>
      <span class="weight-value" [class.is-on]="_selectedTool === _Tool.Pen2">{{
        this._penConfigs['pen2']!.width
      }}</span>
      <span
        class="select-highlight"
        [class.is-on]="_selectedTool === _Tool.Pen2"
      ></span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Pen3"
      (pointerdown)="_onSelectTool(_Tool.Pen3)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Pen3"
        width="18"
        height="14"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.14258 19.8927L12.1926 19.8927C13.5259 19.8927 14.7676 19.2344 15.5092 18.126C16.2509 17.026 16.4009 15.626 15.9009 14.3927L13.2092 7.73438L7.05091 7.73438L2.14258 19.8927Z"
          fill="currentColor"
          [attr.fill]="this._penConfigs['pen3']!.color"
          [attr.fill-opacity]="this._penConfigs['pen3']!.opacity"
        />
        <path
          d="M10.1359 0.11084L7.46094 6.73584L12.8109 6.73584L10.1359 0.11084Z"
          fill="currentColor"
          [attr.fill]="this._penConfigs['pen3']!.color"
          [attr.fill-opacity]="this._penConfigs['pen3']!.opacity"
        />
      </svg>
      <span class="weight-value" [class.is-on]="_selectedTool === _Tool.Pen3">{{
        this._penConfigs['pen3']!.width
      }}</span>
      <span
        class="select-highlight"
        [class.is-on]="_selectedTool === _Tool.Pen3"
      ></span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Pen4"
      (pointerdown)="_onSelectTool(_Tool.Pen4)"
      (touchmove)="$event.preventDefault()"
    >
      <svg
        [class.is-on]="_selectedTool === _Tool.Pen4"
        width="18"
        height="14"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.14258 19.8927L12.1926 19.8927C13.5259 19.8927 14.7676 19.2344 15.5092 18.126C16.2509 17.026 16.4009 15.626 15.9009 14.3927L13.2092 7.73438L7.05091 7.73438L2.14258 19.8927Z"
          fill="currentColor"
          [attr.fill]="this._penConfigs['pen4']!.color"
          [attr.fill-opacity]="this._penConfigs['pen4']!.opacity"
        />
        <path
          d="M10.1359 0.11084L7.46094 6.73584L12.8109 6.73584L10.1359 0.11084Z"
          fill="currentColor"
          [attr.fill]="this._penConfigs['pen4']!.color"
          [attr.fill-opacity]="this._penConfigs['pen4']!.opacity"
        />
      </svg>
      <span class="weight-value" [class.is-on]="_selectedTool === _Tool.Pen4">{{
        this._penConfigs['pen4']!.width
      }}</span>
      <span
        class="select-highlight"
        [class.is-on]="_selectedTool === _Tool.Pen4"
      ></span>
    </button>
    <button
      [class.is-on]="_isRulerOn"
      (pointerdown)="_toggleRuler()"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon name="자" type="solid" [class.is-on]="_isRulerOn"></sui-icon>
      <span class="select-highlight" [class.is-on]="_isRulerOn"></span>
    </button>
    <button
      [class.is-on]="_selectedTool === _Tool.Eraser"
      (pointerdown)="_onSelectTool(_Tool.Eraser)"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon
        name="지우개"
        [class.is-on]="_selectedTool === _Tool.Eraser"
        type="solid"
      ></sui-icon>
      <span
        class="select-highlight"
        [class.is-on]="_selectedTool === _Tool.Eraser"
      ></span>
    </button>
    <div class="divider"></div>
    <button
      [disabled]="!_canRedo"
      (pointerdown)="_onRedoButtonClick()"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon name="앞으로 가기"></sui-icon>
    </button>
    <button
      [disabled]="!_canUndo"
      (pointerdown)="_onUndoButtonClick()"
      (touchmove)="$event.preventDefault()"
    >
      <sui-icon name="뒤로가기"></sui-icon>
    </button>
    <div class="divider"></div>
    <button (pointerdown)="_onClearButtonClick()">
      <sui-icon name="휴지통" type="solid"></sui-icon>
    </button>
    <div class="divider"></div>
    <button (pointerdown)="_onChangePageButtonClick(1)">
      <sui-icon name="페이지 앞으로" type="solid"></sui-icon>
    </button>
    <button (pointerdown)="_onChangePageButtonClick(-1)">
      <sui-icon name="페이지 뒤로" type="solid"></sui-icon>
    </button>
    <div class="divider"></div>
    <button (pointerdown)="_onCloseButtonClick()">
      <sui-icon name="엑스"></sui-icon>
    </button>
    <button class="handle" cdkDragHandle>
      <sui-icon name="옮기기" type="solid"></sui-icon>
    </button>
  </div>
  <div class="pen-controls" *ngIf="_selectedPenConfig">
    <div class="palette">
      <div class="colors">
        <ng-container *ngFor="let color of _colors; index as i">
          <div
            class="color"
            [class.is-selected]="_selectedPenConfig.colorIndex === i"
            [style.color]="color.hex"
            [style.border-color]="color.hex + '33'"
            (click)="_onPenColorClick(i, color)"
            [cdkMenuTriggerFor]="
              _selectedPenConfig.colorIndex === i ? colorPickerMenu : null
            "
            [cdkMenuTriggerData]="{ index: i }"
            (cdkMenuClosed)="_colorPickerClosed(); _isColorPickerOpened = false"
            (cdkMenuOpened)="_isColorPickerOpened = true"
          >
            <div class="circle"></div>
            <sui-icon name="체크"></sui-icon>
          </div>
          <br *ngIf="i === _colors.length / 2 - 1" />
        </ng-container>
      </div>
    </div>
    <div class="slider width">
      <viewer-pen-width-slider
        [(width)]="_selectedPenConfig.width"
        (widthChange)="_onPenConfigChanged()"
      ></viewer-pen-width-slider>
    </div>
    <div class="slider opacity">
      <viewer-pen-opacity-slider
        [(opacity)]="_selectedPenConfig.opacity"
        (opacityChange)="_onPenConfigChanged()"
      ></viewer-pen-opacity-slider>
    </div>
  </div>
</div>

<ng-template #colorPickerMenu let-index="index">
  <div class="color-picker" cdkMenu>
    <viewer-color-picker
      (click)="$event.stopPropagation()"
      [initialColor]="_colors[index].hex"
      (colorChange)="_colorChanged(index, $event)"
    ></viewer-color-picker>
  </div>
</ng-template>
